var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.movieCast.length)?_c('section',{staticClass:"movie-cast"},[_c('h1',[_vm._v("Distribution")]),_c('div',{staticClass:"actor-list"},[_c('CastCarousel',{attrs:{"movieCast":_vm.movieCast}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }